import React from 'react';
import styles from '../styles/Header.module.css';
import SessionIndicator from './SessionIndicator';

/**
 * Header Component
 * Displays logo, session indicator, and hamburger menu button
 *
 * Props:
 * - onOpenMenu: Callback to open hamburger menu
 * - upcomingSession: User's upcoming coaching session (optional)
 * - onSessionIndicatorClick: Callback when session indicator is clicked
 * - hideSessionIndicator: Hide the session indicator (when banner is showing)
 */
function Header({ onOpenMenu, upcomingSession, onSessionIndicatorClick, hideSessionIndicator = false }) {
  return (
    <header className={styles.header}>
      <div className={styles.headerContent}>
        <div className={styles.logoContainer}>
          <h1 className={styles.logo}>SOPHIA</h1>
          <div className={styles.statusDot}></div>
        </div>

        {!hideSessionIndicator && (
          <SessionIndicator
            session={upcomingSession}
            onClick={onSessionIndicatorClick}
          />
        )}

        <button onClick={onOpenMenu} className={styles.menuButton} aria-label="Open menu" data-tour="hamburger-menu">
          <span className={styles.hamburgerIcon}>
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>
      </div>
    </header>
  );
}

export default Header;
